export { default } from "./ProductProperties";